<template>
  <div class="widget widget--dobrodelen">
    <header class="widget__header">
      <h1>Nič vas ne stane, če ste <span>dobrodelni</span>.</h1>
    </header>
    <div class="widget__content">
      <div class="widget__person">
        <h2>Podatki o davčnem zavezancu</h2>
        <div class="widget__form">
          <div class="form-controls row">
            <div class="col-sm-12">
              <input class="form-control" placeholder="Ime oz. naziv upravičenca" v-model="input.name">
            </div>
            <div class="col-sm-12">
              <input class="form-control" placeholder="Naselje, ulica, hišna številka" v-model="input.address">
            </div>
            <div class="col-sm-4">
              <input class="form-control" placeholder="Poštna št." v-model="input.postalCode">
            </div>
            <div class="col-sm-8">
              <input class="form-control" placeholder="Pošta" v-model="input.city">
            </div>
            <div class="col-sm-12 form-inline">
              <label>Davčna številka</label>
              <div class="control-container control-container--tax">
                <input class="form-control" maxlength="1" v-model="input.taxArray[0]" @input="focusNext">
                <input class="form-control" maxlength="1" v-model="input.taxArray[1]" @input="focusNext">
                <input class="form-control" maxlength="1" v-model="input.taxArray[2]" @input="focusNext">
                <input class="form-control" maxlength="1" v-model="input.taxArray[3]" @input="focusNext">
                <input class="form-control" maxlength="1" v-model="input.taxArray[4]" @input="focusNext">
                <input class="form-control" maxlength="1" v-model="input.taxArray[5]" @input="focusNext">
                <input class="form-control" maxlength="1" v-model="input.taxArray[6]" @input="focusNext">
                <input class="form-control" maxlength="1" v-model="input.taxArray[7]">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="widget__content">
      <div class="widget__ngo">
        <h2>Zahteva za namenitev dela dohodnine za donacije</h2>
        <p class="widget__text-small">Vsi davčni zavezanci imate možnost odločanja o svoji dohodnini. <strong>Do 1 odstotek</strong> lahko namenite eni izmed organizacij s seznama upravičencev do donacije dohodnine.</p>
        <div class="widget__form">
          <div class="form-controls row">
            <div class="col-sm-12">
              <input class="form-control" :value="name" readonly>
            </div>
            <div class="col-sm-12">
              <input class="form-control" :value="address" readonly>
            </div>
            <div class="col-sm-4">
              <input class="form-control" :value="postalCode" readonly>
            </div>
            <div class="col-sm-8">
              <input class="form-control" :value="city" readonly>
            </div>
            <div class="col-sm-12 form-inline">
              <label>Davčna številka</label>
              <div class="control-container control-container--tax">
                <input class="form-control" maxlength="1" :value="taxNumberArray[0]" readonly>
                <input class="form-control" maxlength="1" :value="taxNumberArray[1]" readonly>
                <input class="form-control" maxlength="1" :value="taxNumberArray[2]" readonly>
                <input class="form-control" maxlength="1" :value="taxNumberArray[3]" readonly>
                <input class="form-control" maxlength="1" :value="taxNumberArray[4]" readonly>
                <input class="form-control" maxlength="1" :value="taxNumberArray[5]" readonly>
                <input class="form-control" maxlength="1" :value="taxNumberArray[6]" readonly>
                <input class="form-control" maxlength="1" :value="taxNumberArray[7]" readonly>
              </div>
            </div>
            <div class="col-sm-12 form-inline">
              <label>Odstotek</label>
              <div class="control-container">
                <input class="form-control" :value="percent" readonly>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="widget__footer">
      <div class="row">
        <div class="col-xs-12">
          <div class="widget__text-small" style="margin-bottom: 10px;">
            Ne shranjujemo nobenih tvojih podatkov. Ko izpolniš obrazec, jih sistem pošlje na strežnik, kjer ustvari PDF in ti ga vrne, ne da bi ob tem shranil tvoje podatke ali PDF datoteko.
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-xs-6">
          <a :href="linkToPDF" download="zahteva_za_namenitev_dela_dohodnine.pdf" target="_blank" class="btn btn-primary btn-sm">PRENESITE PDF</a>
        </div>
        <div class="col-xs-6">
          <div class="widget__link widget__text-small">Več informacij na <a href="https://www.cnvos.si/enprocent/" target="_blank">cnvos.si/enprocent</a></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'widget',
  data() {
    return {
      input: {
        name: '',
        address: '',
        postalCode: '',
        city: '',
        taxArray: [],
      },
    };
  },
  computed: {
    taxNumberArray() {
      if (this.taxNumber && this.taxNumber.length === 8) {
        return this.taxNumber.split('');
      }
      return [0, 0, 0, 0, 0, 0, 0, 0];
    },
    inputTaxNumber() {
      return this.input.taxArray.join('');
    },
    linkToPDF() {
      const selected = `${this.name}|=|${this.taxNumber}|=|${this.percent}`;
      let url = `/pdf/genPDFfromPOST/?template=dobrodelen_pdf&filename=obrazec_enprocent`;
      url += `&source_domain=${this.sourceDomain}`;
      url += `&selected_orgs=${selected}`;
      url += `&name=${this.input.name}`;
      url += `&address=${this.input.address}`;
      url += `&postalCode=${this.input.postalCode}`;
      url += `&city=${this.input.city}`;
      url += `&taxNumber=${this.inputTaxNumber}`;

      return url;
    },
  },
  props: {
    name: { type: String, required: true },
    address: { type: String, required: true },
    postalCode: { type: String, required: true },
    city: { type: String, required: true },
    taxNumber: { type: String, required: true },
    percent: { type: String, required: true },
    sourceDomain: { type: String, required: true },
  },
  methods: {
    focusNext(event) {
      if (event.target && event.target.nextElementSibling && event.target.nextElementSibling.tagName === 'INPUT') {
        event.target.nextElementSibling.select();
      }
    },
  },
};
</script>

<style>
.widget {
  background-color: #f8fafc;
  text-align: left;
}

.widget__header,
.widget__footer {
  background-color: #f3ebee;
  padding: 12px;
}

.widget__header h1 {
  font-size: 20px;
  line-height: 22px;
  color: #402631;
  font-weight: 500;
  margin-top: 5px;
  margin-bottom: 5px;
}

.widget__header h1 span {
  font-weight: 900;
}

.widget__content {
  padding: 12px;
}

.widget__content+.widget__content {
  border-top: 1px solid #bcbfdf;
}

.widget__content h2 {
  font-size: 16px;
  line-height: 20px;
  font-weight: 500;
  margin: 0 0 8px;
}

.widget__form .form-controls {
  padding: 0 12.5px;
}

.widget__form .form-controls>[class*='col-'] {
  padding-right: 2.5px;
  padding-left: 2.5px;
}

.widget__form .form-control {
  margin-bottom: 5px;
}

.widget__form .form-inline label {
  display: inline-block;
  width: calc(100% - 220px);
  font-weight: 400;
  font-size: 12px;
  margin-top: 1px;
}

.widget__form .form-inline .control-container {
  float: right;
}

.widget__form .form-inline .control-container .form-control {
  width: 214px;
  float: left;
  margin-left: 2px;
  padding-left: 8px;
}

.widget__form .form-inline .control-container--tax .form-control {
  width: 25px;
  text-align: center;
  padding-left: 5px;
  padding-right: 5px;
}

.widget__text-small {
  font-size: 10px;
  line-height: 14px;
}

.widget__link {
  margin: 3px 0;
}

.widget__link a {
  text-decoration: none;
  font-weight: 500;
  color: #c29dac;
}

.widget__link a:hover {
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// src/dobrodelen/Widget.vue